<h3 mat-dialog-title class="aza-pa-dialog-title">{{data?.dialogTitle}}</h3>

<div mat-dialog-content class="aza-pa-dialog-content">
    <div class="aza-pa-flex-column">
        <div *ngIf="dashboards" class="duplicate-dashboard-container aza-pa-flex-column">
            <mat-slide-toggle [(ngModel)]="duplicateDashboard" color="primary" (change)="onDoDuplicate($event)">
                {{ 'DUPLICATE_EXISTING_DASHBOARD' | translate }}
            </mat-slide-toggle>
            <mat-form-field *ngIf="duplicateDashboard">
                <mat-label>{{ 'SELECT_DASHBOARD' | translate }}</mat-label>
                <mat-select (selectionChange)="onDashboardToDuplicateSelected($event)">
                    <mat-option *ngFor="let dashboard of dashboards" [value]="dashboard">
                        {{ dashboard.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-form-field class="name-field">
            <mat-label><span translate>NAME</span></mat-label>
            <input type="text" matInput [(ngModel)]="settingItem.name" />
        </mat-form-field>

        <div class="share-container">
            <div>
                <mat-checkbox [(ngModel)]="settingItem.shared" [disabled]="!canShareItem" color="primary">
                    <span translate>SHARE_VIEW_WITH_OTHER_USERS</span>
                </mat-checkbox>
            </div>
            <div *ngIf="settingItem?.shared">
                <mat-checkbox [(ngModel)]="settingItem.view_by_all" [disabled]="!canShareItem" color="primary">
                    <span translate>SHARE_VIEW_TO_ALL_TEAMS</span>
                </mat-checkbox>
                <div *ngIf="!settingItem?.view_by_all" class="teams-container">
                    <div class="aza-pa-flex-row aza-pa-no-gap">
                        <azavista-input-field *ngIf="teamField" [field]="teamField" [value]="teamFieldValue"
                            [canEdit]="canShareItem" [editMode]="canShareItem" [label]="'TEAM' | translate"
                            (valueChanged)="onTeamValueChanged($event)">
                        </azavista-input-field>
                        <button (click)="onAddTeamClicked()" [disabled]="!canShareItem" mat-icon-button>
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div class="aza-pa-flex-column aza-pa-no-gap">
                        <div *ngFor="let team of selectedTeams" class="aza-pa-flex-row aza-pa-no-gap">
                            <button (click)="onRemoveTeamClicked(team)" [disabled]="!canShareItem" mat-icon-button
                                color="warn">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <span>{{team.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
    <azavista-button (click)="onClose()" class="aza-pa-dialog-action-cancel-button"><span
            translate>CANCEL</span></azavista-button>
    <azavista-button (click)="onDelete()" [disabled]="isNew" class="aza-pa-dialog-action-cancel-button"
        color="warn"><span translate>DELETE</span></azavista-button>
    <azavista-button (click)="onSave()" [disabled]="!settingItem.name" color="primary"
        class="aza-pa-dialog-action-apply-button">
        <span translate>SAVE</span>
    </azavista-button>
</div>
